module.exports = __webpack_public_path__ + "assets/img/about.f8c2190e.png";